module.exports = __webpack_public_path__ + "img/dice-yxx3-6.a7893b94.svg";